/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Promise from 'bluebird';
import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { getMemberId } from '@trello/authentication';
import { isEmbeddedInAtlassian } from '@trello/browser';
import { ComponentWrapper, renderComponent } from '@trello/component-wrapper';
import { listLimitsPowerUpId as LIST_LIMITS_POWER_UP_ID } from '@trello/config';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import ReactDOM from '@trello/react-dom-wrapper';

import { isOverLimit } from 'app/scripts/lib/limits';
import { sendPluginUIEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ListBulkMoveCardsView } from 'app/scripts/views/list/ListBulkMoveCardsView';
import { ListCopyView } from 'app/scripts/views/list/ListCopyView';
import { ListMoveView } from 'app/scripts/views/list/ListMoveView';
import { ListSetLimitView } from 'app/scripts/views/list/ListSetLimitView';
import { ListSortView } from 'app/scripts/views/list/ListSortView';
import { PluginView } from 'app/scripts/views/plugin/PluginView';
import { ListMenuTemplate } from 'app/scripts/views/templates/ListMenuTemplate';
import { ButlerListMenuSection } from 'app/src/components/Butler';
import { openCardComposer } from 'app/src/components/CardComposer';
import { LazyListStatusPicker } from 'app/src/components/ListStatusPicker';
import { isBoardCanvasModernizationEnabled } from 'app/src/isBoardCanvasModernizationEnabled';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface ListMenuView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listViewListen: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginActions: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginListSorters: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginListSortersExpiry: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pluginSortersPromise: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderDebounced: any;
}

class ListMenuView extends PluginView {
  static initClass() {
    this.prototype.viewTitleKey = 'list actions';
  }

  events() {
    return {
      'click .js-add-card': 'addCard',
      'click .js-move-list': 'moveList',
      'click .js-copy-list': 'copyList',
      'click .js-open-list-status-picker': 'openListStatusPicker',
      'click .js-list-subscribe': 'toggleSubscribe',

      'click .js-move-cards': 'moveCards',
      'click .js-archive-cards': 'archiveCards',

      'mouseenter .js-sort-cards': 'preloadSortBy',
      'click .js-sort-cards': 'sortBy',

      'click .js-close-list': 'closeList',

      'click .js-plugin-list-action': 'runPluginAction',

      'click .js-set-list-limit': 'setListLimit',
    };
  }

  initialize() {
    this.makeDebouncedMethods('render');

    Analytics.sendScreenEvent({
      name: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    this.listenTo(this.model, 'change:subscribed', this.renderDebounced);
    return this.retain(this.options.pluginActions);
  }

  remove() {
    this.removeButlerSection();
    super.remove(...arguments);
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.pluginActions = _.chain(this.options.pluginActions as any)
      .filter(
        (a) =>
          a && _.isString(a.text) && a.text.length && _.isFunction(a.callback),
      )
      .map((a) =>
        Object.assign(a, {
          icon: pluginIOCache.fromId(a.idPlugin).getIconUrl(),
          name: pluginIOCache.fromId(a.idPlugin).getName(),
        }),
      )
      .sortBy('text')
      .value();

    this.$el.html(
      ListMenuTemplate({
        editable: this.model.editable(),
        hasSortableCards: this.model.cardList.length > 1,
        subscribed: this.model.get('subscribed'),
        canCopyList:
          !isOverLimit('lists', 'totalPerBoard', this.model.get('limits')) &&
          !isOverLimit('lists', 'openPerBoard', this.model.get('limits')),
        pluginActions: this.pluginActions,
        listLimitsEnabled: this.model.getBoard().isListLimitsPowerUpEnabled(),
        isEmbeddedInAtlassian: isEmbeddedInAtlassian(),
        isTemplate: this.model.getBoard().isTemplate(),
      }),
    );

    this.renderButlerSection();

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addCard(e: any) {
    stopPropagationAndPreventDefault(e);

    PopOver.hide();

    if (isBoardCanvasModernizationEnabled()) {
      openCardComposer({
        listId: this.model.id,
        position: 0,
      });
    } else {
      this.model.getBoard().composer.save({
        list: this.model,
        index: 0,
        vis: true,
      });
    }

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'addCardMenuItem',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveList(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'moveListMenuItem',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id || '',
        },
        board: {
          id: this.model.getBoard()?.id || '',
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id || '',
        },
      },
    });

    PopOver.pushView({
      view: new ListMoveView({
        model: this.model,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copyList(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'copyListMenuItem',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id || '',
        },
        board: {
          id: this.model.getBoard()?.id || '',
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id || '',
        },
      },
    });

    PopOver.pushView({
      view: new ListCopyView({
        model: this.model,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openListStatusPicker(e: any) {
    stopPropagationAndPreventDefault(e);

    PopOver.pushView({
      // TODO: Localize!
      getViewTitle: () => 'List status',
      reactElement: (
        <ComponentWrapper key="listStatusPicker">
          <LazyListStatusPicker idList={this.model.id} />
        </ComponentWrapper>
      ),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleSubscribe(e: any) {
    e?.preventDefault();
    const taskName = 'edit-list/subscribed';
    const source = 'listMenuInlineDialog';
    const traceId = Analytics.startTask({
      taskName,
      source,
    });
    if (this.model.get('subscribed')) {
      this.model.subscribe(
        false,
        tracingCallback({ taskName, source, traceId }),
        { traceId },
      );

      Analytics.sendTrackEvent({
        action: 'unsubscribed',
        actionSubject: 'list',
        source: 'listMenuInlineDialog',
        containers: {
          list: {
            id: this.model.id || '',
          },
          board: {
            id: this.model.getBoard()?.id || '',
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id || '',
          },
        },
      });
    } else {
      this.model.subscribe(
        true,
        tracingCallback({ taskName, source, traceId }),
        { traceId },
      );

      Analytics.sendTrackEvent({
        action: 'subscribed',
        actionSubject: 'list',
        source: 'listMenuInlineDialog',
        containers: {
          list: {
            id: this.model.id || '',
          },
          board: {
            id: this.model.getBoard()?.id || '',
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id || '',
          },
        },
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveCards(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'moveAllCardsMenuItem',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id || '',
        },
        board: {
          id: this.model.getBoard()?.id || '',
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id || '',
        },
      },
    });

    PopOver.pushView({
      view: new ListBulkMoveCardsView({
        model: this.model,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  archiveCards(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'archiveAllCardsMenuItem',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id || '',
        },
        board: {
          id: this.model.getBoard()?.id || '',
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id || '',
        },
      },
    });

    Confirm.pushView('archive all cards', {
      model: this.model,
      confirmBtnClass: 'nch-button nch-button--danger',
      fxConfirm: () => {
        PopOver.hide();

        const openCards = _.clone(this.model.cardList.models);
        for (const card of Array.from(openCards)) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          card.set({ closed: true });
        }

        return this.model.run('archiveAllCards', {}, this.listViewListen);
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadPluginSorters(timeout: any) {
    return pluginRunner
      .all({
        command: 'list-sorters',
        board: this.model.getBoard(),
        list: this.model,
        timeout,
      })
      .catch(() => [])
      .then((pluginListSorters) => {
        // limit to 5 sorts per plugin
        return _.chain(pluginListSorters)
          .groupBy('idPlugin')
          .map((val, idPlugin) => val.slice(0, 5))
          .flatten()
          .value();
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preloadSortBy(e: any) {
    if (this.pluginSortersPromise == null) {
      return (this.pluginSortersPromise = this.loadPluginSorters(500).then(
        (pluginListSorters) => {
          this.pluginSortersPromise = null;
          this.pluginListSorters = pluginListSorters;
          this.pluginListSortersExpiry = Date.now() + 5000;
          return pluginListSorters;
        },
      ));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortBy(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'sortListMenuItem',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id || '',
        },
        board: {
          id: this.model.getBoard()?.id || '',
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id || '',
        },
      },
    });

    let pluginListSorters = [];

    if (
      this.pluginListSorters != null &&
      this.pluginListSortersExpiry > Date.now()
    ) {
      ({ pluginListSorters } = this);
    } else if (this.pluginSortersPromise != null) {
      pluginListSorters = this.pluginSortersPromise;
    } else {
      // @ts-expect-error TS(2740): Type 'Bluebird<any[]>' is missing the following pr... Remove this comment to see the full error message
      pluginListSorters = this.loadPluginSorters(150);
    }

    // eslint-disable-next-line @typescript-eslint/no-shadow
    return Promise.resolve(pluginListSorters).then((pluginListSorters) => {
      PopOver.pushView({
        // @ts-expect-error
        view: new ListSortView({
          model: this.model,
          pluginListSorters,
        }),
      });
      return (this.pluginListSorters = null);
    });
  }

  renderButlerSection() {
    const reactRoot = this.el.querySelector('.js-list-menu-butler-section');
    if (reactRoot) {
      const memberId = getMemberId();
      const board = this.model.getBoard();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const isMember = board.memberList.some((m: any) => m.id === memberId);
      // Non board members will get a server "NOT_AUTHORIZED" error if they try to
      // create a rule, so lets hide the ability to create rules for them
      if (isMember) {
        renderComponent(
          <ButlerListMenuSection
            listName={this.model.get('name')}
            idList={this.model.id}
            idBoard={this.model.getBoard()?.id}
            idOrganization={this.model.getBoard()?.getOrganization()?.id}
          />,
          reactRoot,
        );
      }
    }
  }

  removeButlerSection() {
    const reactRoot = this.el.querySelector('.js-list-menu-butler-section');
    if (reactRoot) {
      ReactDOM.unmountComponentAtNode(reactRoot);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setListLimit(e: any) {
    stopPropagationAndPreventDefault(e);

    sendPluginUIEvent({
      idPlugin: LIST_LIMITS_POWER_UP_ID,
      idBoard: this.model.getBoard().id,
      event: {
        action: 'clicked',
        actionSubject: 'option',
        // @ts-expect-error TS(2322): Type '"powerUpListAction"' is not assignable to ty... Remove this comment to see the full error message
        actionSubjectId: 'powerUpListAction',
        source: 'listMenuInlineDialog',
      },
    });
    return PopOver.pushView({
      view: new ListSetLimitView({
        model: this.model,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  runPluginAction(e: any) {
    stopPropagationAndPreventDefault(e);

    const target =
      this.pluginActions[
        $(e.target, this.$el).closest('.js-plugin-list-action').data('index')
      ];

    const { idPlugin } = target;

    const traceId = Analytics.startTask({
      taskName: 'run-pluginCommand/listAction',
      source: 'listMenuInlineDialog',
      attributes: {
        idPlugin,
      },
    });

    sendPluginUIEvent({
      idPlugin,
      idBoard: this.model.getBoard().id,
      event: {
        action: 'clicked',
        actionSubject: 'option',
        // @ts-expect-error TS(2322): Type '"powerUpListAction"' is not assignable to ty... Remove this comment to see the full error message
        actionSubjectId: 'powerUpListAction',
        source: 'listMenuInlineDialog',
      },
    });

    return typeof target.callback === 'function'
      ? target
          .callback({ el: this.el, list: this.model })
          .then(() => {
            Analytics.taskSucceeded({
              taskName: 'run-pluginCommand/listAction',
              traceId,
              source: 'listMenuInlineDialog',
              attributes: {
                idPlugin,
              },
            });
          })
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .catch((error: any) => {
            Analytics.taskFailed({
              taskName: 'run-pluginCommand/listAction',
              traceId,
              source: 'listMenuInlineDialog',
              attributes: {
                idPlugin,
              },
              error,
            });
            throw error;
          })
      : undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeList(e: any) {
    stopPropagationAndPreventDefault(e);

    const { model } = this;

    Analytics.sendTrackEvent({
      action: 'archived',
      actionSubject: 'list',
      source: 'listMenuInlineDialog',
      containers: {
        list: {
          id: this.model.id || '',
        },
        board: {
          id: this.model.getBoard()?.id || '',
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id || '',
        },
      },
    });

    PopOver.hide();

    const source = 'listMenuInlineDialog';
    const taskName = 'edit-list/closed';

    const traceId = Analytics.startTask({
      taskName,
      source: source,
    });

    model.close(
      { traceId },
      tracingCallback({
        taskName,
        source,
        traceId,
      }),
    );

    return false;
  }
}

ListMenuView.initClass();
export { ListMenuView };
